import { ButtonToggle, Icon } from "@qw/ui";
import type { FC } from "react";
import { useBook } from "@/providers/use-book";

export const BookToggle: FC = () => {
  const { isBookOpen, setIsBookOpen } = useBook();
  return (
    <ButtonToggle active={isBookOpen} onClick={() => setIsBookOpen((open) => !open)}>
      <Icon icon={isBookOpen ? "left_panel_close" : "left_panel_open"} />
    </ButtonToggle>
  );
};
